import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
var Page = {
  collapseBreakpoint: 'widescreen',
  WithSidebar: {
    defaultProps: {
      sidebarProps: {
        hideCloseButton: true
      }
    },
    Sidebar: {
      base: css(["background-color:", ";"], palette('primary800'))
    },
    DesktopSidebarWrapper: {
      base: css(["z-index:1;"])
    }
  },
  Content: {
    base: css(["@media screen and (max-width:", "px){padding-left:1rem;padding-right:1rem;}"], theme('fannypack.layout.tabletBreakpoint')),
    wrapper: css(["background-color:white;border-bottom:1px solid ", ";"], palette('white900'))
  }
};
export default Page;